export default __webpack_public_path__ + "static/media/paymentMethods.9d17b736.svg";